import { Component, OnInit, inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { taskStatuses } from 'src/assets/data/task-statuses';
import { ScheduleDetailComponent, TASK_DETAIL_DIALOG_SIZE } from '../schedule-detail/schedule-detail.component';
import { CalendarCommonService } from 'src/app/shared/services/ind-calendar.service';
import { AppScheduleTasksListComponent } from '../schedule-tasks-list/schedule-tasks-list.component';

@Component({
    selector: 'app-schedule-tasks-list-modal',
    templateUrl: './schedule-tasks-list-modal.component.html',
    styleUrls: ['./schedule-tasks-list-modal.component.scss'],
    imports: [AppScheduleTasksListComponent]
})
export class ScheduleTasksListModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ScheduleTasksListModalComponent>>(MatDialogRef);
  eventData = inject(MAT_DIALOG_DATA, { optional: true });
  dialog = inject(MatDialog);
  private readonly calendarDataService = inject(CalendarCommonService);

  data: any = {};
  events: any = [];
  taskStatuses: any[] = taskStatuses;
  selectedId: string = '';
  openDate: Date = new Date();

  ngOnInit(): void {
    this.data = this.eventData.event;
    this.openDate = this.eventData.event.date;

    this.calendarDataService.dailyTaskData.subscribe((updatedData) => {
      if (updatedData) {
        // Filtra solo las tareas cuya fecha coincide con la del modal
        this.events = updatedData
          .filter((event: any) => {
            const eventDate = new Date(event.event.data.schudeledDate);
            return eventDate.toDateString() === this.openDate.toDateString(); // Compara solo la fecha, sin horas
          })
          .sort((a: any, b: any) => {
            const dateA = new Date(a.event.data.schudeledDate).getTime();
            const dateB = new Date(b.event.data.schudeledDate).getTime();
            return dateA - dateB; // Orden ascendente (primero el más temprano)
          });
      }
    });
  }

  getStatusColor(status: any) {
    return this.taskStatuses.find((x) => x.value == status).eventColor
      .secondary;
  }

  getStatusSelectedColor(status: any) {
    return this.taskStatuses.find((x) => x.value == status).eventColor.primary;
  }

  getStatusDescription(status: any) {
    return this.taskStatuses.find((x) => x.value == status).name;
  }

  expandDetail(id: string) {
    this.selectedId = this.selectedId == id ? '' : id;
  }

  dialogAction(event: any): void {
    let CurrentDialog = this.dialog.open(ScheduleDetailComponent, {
      ...TASK_DETAIL_DIALOG_SIZE,
      panelClass: '.detailClass',
      data: { event: event.event, action: 'view' },
    });

    CurrentDialog.afterClosed().subscribe((result) => {
      this.eventData.event.events.find(
        (x: { event: { data: { id: any } } }) =>
          x.event.data.id == event.event.data.id
      ).event = event.event;
    });
  }
}
